export default __webpack_public_path__ + "static/media/WNLhero2.7a791a14.jpg";